var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12 4-.534 8.009c-.047.701-.07 1.052-.221 1.318a1.33 1.33 0 0 1-.577.54c-.276.133-.627.133-1.33.133H6.663c-.703 0-1.055 0-1.33-.133a1.33 1.33 0 0 1-.577-.54c-.152-.266-.175-.617-.222-1.318L4 4M2.667 4h10.666m-2.666 0-.18-.541c-.175-.525-.263-.787-.425-.981a1.33 1.33 0 0 0-.535-.385C9.292 2 9.015 2 8.462 2h-.924c-.553 0-.83 0-1.065.093a1.33 1.33 0 0 0-.535.385c-.162.194-.25.456-.424.98L5.334 4"
  })));
};
export default SvgTrash;